import React from 'react'
import TableHeader from './TableHeader'

const ReferrerRankingsList = ({
  referrerRankings = [],
  total = 0,
}) => {
  return (
    <React.Fragment>
      <div className='MainHeader'>
        <div className='MainHeader__left'>
          <h2 className='MainHeader__h2'>Referrer Rankings list</h2>
          <p className='MainHeader__left__p'></p>
        </div>
      </div>

      <div className='Table Table--referrers-rankings-list'>
        {(() => {
          const columnHeaders = [
            {
              label: 'Referrer ID',
            },
            {
              label: 'Total',
              sortKey: 'total_invites'
            },
            {
              label: 'Unique',
              sortKey: 'different_uuid_invites'
            },
          ]

          return (
            <div className='Table__row'>
              {columnHeaders.map((header, key) => (
                <TableHeader
                  key={key}
                  header={header}
                />
              ))}
            </div>
          )
        })()}

        {referrerRankings.map((referrer_ranking, i) => (
          <div
            className='Table__row'
            key={`${i}_${referrer_ranking.id}`}
          >
            <div className='Table__col'>
              <a className='DotTooltip__link' href={`/${gon.currentProvider}/users/${referrer_ranking.id}`}>{referrer_ranking.id}</a>
            </div>

            <div className='Table__col'>
              {referrer_ranking.totalInvites}
            </div>

            <div className='Table__col'>
              {referrer_ranking.differentUuidInvites}
            </div>

          </div>
        ))}
      </div>
    </React.Fragment>
  );
}

export default ReferrerRankingsList
